// extracted by mini-css-extract-plugin
module.exports = {"helloUser":"Home_helloUser__MbMX3","logoHolder":"Home_logoHolder__36fXI","features":"Home_features__1AwIM"};